import en from './en';
import he from './he';

export default {
    en: {
        message: en
    },
    he: {
        message: he
    },
}